/**
 * 讲述人展示：一位客户可以有多本书（给爸妈各做一本），每本书各写谁。
 * 与服务端 advisor-cards.ts 的 narratorLabel 同一口径。
 */
import type { BookNarratorDto } from '../../../api/advisor';

/** 「王秀英（母亲）」/ 只有姓名 / 只有关系；都没填返回空串 */
export function narratorText(name?: string | null, relation?: string | null): string {
  const n = name?.trim();
  const r = relation?.trim();
  if (n && r) return `${n}（${r}）`;
  return n || r || '';
}

/** 客户名下各本书的讲述人，用顿号连起来；没有返回 '-' */
export function narratorsText(narrators: BookNarratorDto[]): string {
  const parts = narrators.map((x) => narratorText(x.narratorName, x.narratorRelation)).filter(Boolean);
  return parts.length ? parts.join('、') : '-';
}
